import React, {useCallback} from 'react';
import {Task, TaskWithEditInfo} from '../../../../services';
import {
  Button,
  DropTargetLayout,
  Layout,
  LayoutScrollable,
  Spacer,
  Text,
} from '@di-nxt/components';
import {UnassignedTask} from './UnassignedTask';
import {t} from '../../../../localization';

type Props = {
  show: boolean;
  unassignedTasks: Task[];
  onHideSidebar: () => void;
  onBeginDrag?: (taskId: number) => void;
  onEndDrag?: (taskId: number) => void;
  onBeginHover?: (taskId: number) => void;
  onEndHover?: (taskId: number) => void;
  onDrop?: (taskId: number) => void;
};
export const UnassignedTasksSidebar: React.FC<Props> = ({
  show,
  unassignedTasks,
  onHideSidebar,
  onBeginDrag,
  onEndDrag,
  onBeginHover,
  onEndHover,
  onDrop,
}) => {
  const handleDragBegin = useCallback(
    (task: TaskWithEditInfo) => onBeginDrag && onBeginDrag(task.id),
    [onBeginDrag],
  );
  const handleDragEnd = useCallback(
    (task: TaskWithEditInfo, didDrop: boolean) => {
      !didDrop && onEndDrag && task && onEndDrag(task.id);
    },
    [onEndDrag],
  );

  const handleBeginHover = useCallback(
    (task: TaskWithEditInfo) => {
      //console.log('UnassignedTasksSidebar.handleBginHover');
      onBeginHover && onBeginHover(task.id);
    },
    [onBeginHover],
  );
  const handleEndHover = useCallback(
    (task: TaskWithEditInfo) => onEndHover && task && onEndHover(task.id),
    [onEndHover],
  );
  const handleDrop = useCallback(
    (task: TaskWithEditInfo) => onDrop && onDrop(task.id),
    [onDrop],
  );

  return show ? (
    <Layout vertical width={280} raised>
      {/*Header*/}
      <Layout
        paddingVertical="10"
        paddingHorizontal="20"
        paddingLeft="14"
        horizontal>
        <Layout flex align="center">
          <Button
            kind="Clear"
            size="Small"
            leftIcon="doubleArrowRight"
            onPress={onHideSidebar}
          />
          <Spacer width="4" />
          <Text variant="inline_16_emphasis">
            {t('screens.schedule.tasks.unassignedTasks')}
          </Text>
        </Layout>
        <Layout align="center">
          <Text variant="inline_14_default">{unassignedTasks.length}</Text>
        </Layout>
      </Layout>
      {/** content */}
      <DropTargetLayout
        type="Task"
        flex
        vertical
        onBeginHover={handleBeginHover}
        onEndHover={handleEndHover}
        onDrop={handleDrop}>
        <LayoutScrollable>
          {unassignedTasks.map(task => (
            <Layout vertical key={task.id} paddingHorizontal="20">
              <UnassignedTask
                task={task}
                key={task.id}
                onBeginDrag={handleDragBegin}
                onEndDrag={handleDragEnd}
              />
              <Spacer height="10" />
            </Layout>
          ))}
        </LayoutScrollable>
      </DropTargetLayout>
    </Layout>
  ) : null;
};
